'use strict';

module.exports = function (data) {

	function getIndexOfBirdInSet(set, birdName) {
		for (var i = 0; i < set.birds.length; i++) {
			if (set.birds[i].name === birdName) {
				return i;
			}
		}

		return -1;
	}

	function isBirdInSet(set, birdName) {
		return getIndexOfBirdInSet(set, birdName) >= 0;
	}

	function removeBirdsFromSetThatAreNotInTheFirstSet(firstSet, secondarySet) {
		for (var j = secondarySet.birds.length - 1; j >= 0; j--) {
			if (!isBirdInSet(firstSet, secondarySet.birds[j].name)) {
				data[i].birds.splice(j, 1);
			}
		}
	}

	function sortSetByCount(set) {
		set.birds.sort(function (left, right) {
			if (left.count < right.count) {
				return 1;
			} else if (left.count > right.count) {
				return -1;
			} else {
				if (left.name < right.name) {
					return -1;
				} else if (left.name > right.name) {
					return 1;
				} else {
					return 0;
				}
			}
		});
	}

	function padAndSortSetByFirstSet(firstSet, secondarySet) {
		var birds = [];
		for (var i = 0; i < firstSet.birds.length; i++) {
			var index = getIndexOfBirdInSet(secondarySet, firstSet.birds[i].name);
			if (index > -1) {
				birds.push(secondarySet.birds[index]);
			} else {
				birds.push({ name: firstSet.birds[i].name, count: 0 });
			}
		}

		secondarySet.birds = birds;
	}

	// Sort the first set
	sortSetByCount(data[0]);

	// Remove elements from secondary sets that are not in the first
	// and pad and sort sets by the first one
	for (var i = 1; i < data.length; i++) {
		removeBirdsFromSetThatAreNotInTheFirstSet(data[0], data[i]);
		padAndSortSetByFirstSet(data[0], data[i]);
	}

	return data;
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/charting/charting-sort-and-match-bird-data.js
// module id = 240
// module chunks = 0